import { format } from 'date-fns';
import styled from 'styled-components';

import { TerminatedIcon } from '@/assets/icons/investment-status/treminated';
import { themeVar } from '@/styles/theme';
import { Status, StatusIconWrap } from './index';

interface TerminatedStatusRowProps {
  status: string;
  date: Date;
  isMobile?: boolean;
}

export const TerminatedStatusRow = ({ status, date, isMobile = false }: TerminatedStatusRowProps) => {
  return (
    <Row>
      <StatusIconWrap>
        <TerminatedIcon width={18} height={18} fill={themeVar('context.error')} />
      </StatusIconWrap>
      <Status isMobile={isMobile} color={themeVar('context.error')}>
        {status}
      </Status>
      <DateBlock>{format(new Date(date), 'LLL d, yyyy')}</DateBlock>
    </Row>
  );
};

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${themeVar('layer.1')};
  border-radius: 4px;
  padding: 7px 12px;
`;

const DateBlock = styled.span`
  color: ${themeVar('font.base')};
  font-family: 'Blinker';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding-left: 20px;
`;
